export default __webpack_public_path__ + "static/media/Dial_Black_Red.78d35d38.png";